export const alphaNumericRule = {
  message: 'Should be alphanumeric',
  pattern: new RegExp(/^[a-z0-9]+$/i),
};

export const NumberRule = {
  pattern: new RegExp('^[-]?[0-9]+$'),
  message: 'should be a number',
};

export const alphaNumericWithSpecialChars = {
  message: 'only alphanumeric, "&", "/", "-" characters are allowed',
  pattern: new RegExp(/^[a-z0-9&/-]+$/i),
};
